import Api from './Api'

// Le risposte di /prodotti sono { ok, data }: il contenuto, oppure null se la richiesta è fallita
export const contenuto = res => (res.ok && res.data && res.data.ok !== false ? res.data.data : null)

const e = encodeURIComponent

const senzaVuoti = filtri => Object.fromEntries(Object.entries(filtri).filter(([, v]) => v !== '' && v != null))

export const ProdottiApi = {
  elenco: filtri => Api.get('/prodotti', senzaVuoti(filtri)),
  scheda: id => Api.get(`/prodotti/${e(id)}`),
  crea: corpo => Api.post('/prodotti', corpo),
  aggiorna: (id, corpo) => Api.patch(`/prodotti/${e(id)}`, corpo),
  aggiungiVariante: (id, corpo) => Api.post(`/prodotti/${e(id)}/varianti`, corpo),
  aggiornaVariante: (id, articoloId, corpo) => Api.patch(`/prodotti/${e(id)}/varianti/${e(articoloId)}`, corpo),
  unisci: (id, corpo) => Api.post(`/prodotti/${e(id)}/unisci`, corpo),
  pubblica: id => Api.post(`/prodotti/${e(id)}/pubblica`),
  ritira: id => Api.post(`/prodotti/${e(id)}/ritira`)
}
